import { Col, Row, Tooltip } from "antd";
import Widget from "./Widget";
import React from "react";


const WidgetContainer = ({ widgets, center=false, span=6, color }) => {
    return (
            <Row gutter={[48, 16]} justify={center ? 'center' : 'start'}>
              {widgets.map((app) => (
                <Col key={app.label} span={span}>
                  <Widget config={app} color={color} />
                </Col>
              ))}
            </Row>
    )
}

export default WidgetContainer;